import React, { useMemo } from 'react'

import { defaultSort } from '../../../../constants'
import { useStoreContext } from '../../../../contexts/StoreContext'
import { useProductWithLowStock } from '../../../../hooks/useProductWithLowStock'
import useWindowDimensions from '../../../../hooks/useWindowDimensions'
import { useProductsQuery } from '../../../../sdk/product/useProductsQuery'
import { getClubName } from '../../../../utils/formatAccountName'
import { ProductShelfSkeleton } from '../../ProductShelf'
import { ProductShelfByFilters } from '../../ProductShelf/ProductShelfByFilters'

import type { ProductLayout } from '../../../../types/Product'

interface ClubProductsSectionProps {
  customQtyItems?: number
  title?: string
  description?: string
  titleColor?: string
  location: string
  layout?: ProductLayout
}

export const ClubProductsSection = ({
  customQtyItems,
  title,
  description,
  location,
  titleColor,
  layout,
}: ClubProductsSectionProps) => {
  const { account, activatePlusFriendBadge } = useStoreContext()
  const { data: productList } = useProductsQuery({
    first: 10,
    sort: defaultSort,
    selectedFacets: [{ key: 'preco2', value: 'true' }],
  })

  const products = useMemo(
    () => productList?.edges.map(({ node }) => node),
    [productList]
  )

  const { productsWithLowStock, loading: productsWithLowStockLoading } =
    useProductWithLowStock(products)

  const { width } = useWindowDimensions()

  const clubName = getClubName(account, activatePlusFriendBadge)

  if (productsWithLowStockLoading || !width) {
    return (
      <section className="page__section / shelf-section-grid shelf-section-content-grid ">
        <ProductShelfSkeleton />
      </section>
    )
  }

  if (!productsWithLowStock?.length) {
    return null
  }

  return (
    <ProductShelfByFilters
      type="club"
      queryInput={{
        firstItems: 10,
        selectedFacets: [{ key: 'preco2', value: 'true' }],
        sort: defaultSort,
      }}
      title={title ?? clubName}
      link="/s/?clubProducts"
      id={location}
      customQtyItems={customQtyItems}
      description={description}
      titleColor={titleColor}
      SeeMoreText={'Seus produtos favoritos!'}
      layout={layout}
    />
  )
}
